import React from 'react';

import { useT } from '@transifex/react';
import styled from 'styled-components';
import { Modal as AntdModal } from 'antd';
import { LoadingIndicator } from '@/components/application/loading-indicator/loading-indicator';
import { IModal } from './types';
import StyledModal, { ModalLoadContainer, Variants } from './style';

type StyledAntdModalProps = {
  $variant?: Variants;
  $isFullScreen?: boolean;
  $isWithFooter?: boolean;
  $styles?: string;
};

const StyledAntdModal = styled(AntdModal)<StyledAntdModalProps>`
  ${StyledModal}
`;

export type { IModal } from './types';

const Modal = ({
  children,
  visible,
  onClose,
  disableSubmitButton = false,
  onSubmit = () => null,
  variant,
  loading,
  fullscreen,
  width,
  styles,
  ...restProps
}: IModal): JSX.Element => {
  const t = useT();
  return (
    <StyledAntdModal
      $styles={styles}
      $isFullScreen={fullscreen}
      $isWithFooter={!!restProps.footer}
      style={
        fullscreen
          ? {
              top: '0%',
              left: '0%',
              maxWidth: '100%',
              padding: 0,
            }
          : {}
      }
      $variant={variant}
      open={visible}
      onCancel={onClose}
      onOk={onSubmit}
      okButtonProps={{ disabled: disableSubmitButton }}
      width={fullscreen ? '100%' : width}
      {...restProps}
    >
      {loading ? (
        <ModalLoadContainer>
          <LoadingIndicator type="line-simple" size="lg" label={t('Loading')} />
        </ModalLoadContainer>
      ) : (
        children
      )}
    </StyledAntdModal>
  );
};

export default Modal;
